import { render, staticRenderFns } from "./HealthAssessment.vue?vue&type=template&id=19d551d4&scoped=true"
import script from "./HealthAssessment.vue?vue&type=script&lang=js"
export * from "./HealthAssessment.vue?vue&type=script&lang=js"
import style0 from "./HealthAssessment.vue?vue&type=style&index=0&id=19d551d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d551d4",
  null
  
)

export default component.exports